module.exports = __webpack_public_path__ + "static/media/MCRN.99b18dbd.svg";